import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTaskFilters } from '../ducks/selectors'
import { setTaskFiltersRoutine } from '../ducks/actions'
import TaskOriginPicker from './TaskOriginPicker'

const TaskTypeSegment = () => {
  const dispatch = useDispatch()
  const filters = useSelector(selectTaskFilters)

  return (
    <TaskOriginPicker
      value={filters?.origin || null}
      onChange={origin => dispatch(setTaskFiltersRoutine({ origin, type: null }))}
    />
  )
}

export default TaskTypeSegment
